import { render } from "./DarkModeLacen.vue?vue&type=template&id=55ca74af&scoped=true"
import script from "./DarkModeLacen.vue?vue&type=script&lang=js"
export * from "./DarkModeLacen.vue?vue&type=script&lang=js"

import "./DarkModeLacen.vue?vue&type=style&index=0&id=55ca74af&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55ca74af"]])

export default __exports__